import React, { useState } from "react";
import {
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavItem,
  MDBNavLink,
  MDBNavbarToggler,
  MDBCollapse,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
  MDBIcon,
} from "mdbreact";
import AnchorLink from "react-anchor-link-smooth-scroll";
export default function Navigation() {
  const [isOpen, setOpen] = useState(false);
  const toggleCollapse = () => {
    setOpen(!isOpen);
  };
  const scrolltotop = () => {
    const c = document.documentElement.scrollTop || document.body.scrollTop;
    if (c > 0) {
      window.requestAnimationFrame(scrolltotop);
      window.scrollTo(0, c - c / 8);
    }
  };
  return (
    <MDBNavbar
      color="unique-color-dark"
      scrolling={true}
      dark
      expand="md"
      fixed="top"
    >
      <MDBNavbarBrand>
        <div onClick={scrolltotop} style={{ display: "inline-flex" }}>
          {" "}
          <a className={"logo"}></a>
          <a className="logo-text">Mamba House</a>
        </div>{" "}
      </MDBNavbarBrand>
      <MDBNavbarToggler onClick={toggleCollapse} />
      <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
        <MDBNavbarNav right>
          <MDBNavItem>
            <AnchorLink
              href="#home"
              onClick={scrolltotop}
              style={{ color: "white" }}
            >
              Home
            </AnchorLink>
          </MDBNavItem>
          <MDBNavItem>
            <AnchorLink href="#work" style={{ color: "white" }}>
              Work
            </AnchorLink>
          </MDBNavItem>
          <MDBNavItem>
            <AnchorLink href="#project" style={{ color: "white" }}>
              Projects
            </AnchorLink>
          </MDBNavItem>
          <MDBNavItem active>
            <AnchorLink href="#contact" style={{ color: "white" }}>
              Contact Us
            </AnchorLink>
          </MDBNavItem>
          <MDBNavItem>
            <AnchorLink href="#team" style={{ color: "white" }}>
              Team
            </AnchorLink>
          </MDBNavItem>
        </MDBNavbarNav>
        <MDBNavbarNav right>
          <MDBNavItem className="login">
            <AnchorLink href="#">Login</AnchorLink>
          </MDBNavItem>
        </MDBNavbarNav>
      </MDBCollapse>
    </MDBNavbar>
  );
}
